export function getContext2dOrThrow(canvas) {
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('canvas 2d context is null');
  }
  return ctx;
}
